import { jsxs as f, jsx as l } from "react/jsx-runtime";
import "react";
import { p as s } from "../../index-DB0QlRo7.mjs";
import { GradientButton as h } from "../GradientButton/GradientButton.js";
import { Button as u } from "../Button/Button.js";
import { classes as b } from "../../utils/helpers.js";
import '../../assets/CtaBlock.css';const c = {
  "cta-block__title-img": "_cta-block__title-img_1ia8j_5"
};
function A({
  title: o = "",
  titleImageUrl: a = "",
  content: r = "",
  type: t = "internal-link",
  cta: e = { label: "", href: "", type: "" },
  ctaButtonStyle: i = "gradient",
  btnGradientStartColor: d = "",
  btnGradientEndColor: m = "",
  btnFlatColors: _ = {
    bgColor: "",
    bgHoverColor: "",
    color: "",
    hoverColor: "",
    borderColor: "",
    borderHoverColor: ""
  }
}) {
  const g = i === "gradient" ? h : u, p = i === "gradient" ? {
    gradientStartColor: d,
    gradientEndColor: m
  } : {
    customColors: _
  }, n = {
    "play-video": {
      label: "View Promo",
      target: null,
      rel: null
    },
    "internal-link": {
      label: "View More",
      target: "_self",
      rel: null
    },
    "external-link": {
      label: "Learn More",
      target: "_blank",
      rel: "noreferrer"
    }
  }, k = (C) => {
    console.log("cta clicked", C);
  };
  return /* @__PURE__ */ f(
    "cta-block",
    {
      style: {
        "--title-image": `url(${a})`
      },
      children: [
        o !== "" && /* @__PURE__ */ l(
          "h1",
          {
            className: b([
              "h2",
              a ? c["cta-block__title-img"] : null
            ]),
            children: a ? /* @__PURE__ */ l("span", { className: "sr-only", children: o }) : s(o)
          }
        ),
        r !== "" && /* @__PURE__ */ l("div", { className: c["cta-block__content"], children: typeof r == "string" ? s(r) : r }),
        /* @__PURE__ */ l("cta-wrapper", { children: /* @__PURE__ */ l(
          g,
          {
            classname: b([c["cta-block__cta"], "cta-block__cta"]),
            href: e.href,
            label: e.label ? e.label : n[t].label,
            onClick: e.type === "play-video" ? k : () => !0,
            rel: n[t].rel,
            target: n[t].target,
            ...p
          }
        ) })
      ]
    }
  );
}
export {
  A as CtaBlock,
  A as default
};
